<template>
  
    <div class="h-100">
   <!-- <i class="fas fa-pen"></i> -->
        <b-loading :is-full-page="true" :active.sync="isLoadingPage"></b-loading>
        <!-- <p  class="has-text-left " ><span class="is-size-3 has-text-weight-semibold "></span><span class="is-size-4">{{forms.name}}</span></p> -->
        <!-- <i class="fas fa-check"></i> -->
        <div class="h-100">

        <div class="columns h-100 is-marginless " :class="{fixhidden: showprofile}">

        <div  @click="showprofile = !showprofile" class="circlehamburger" :class="{outani : showprofile}">
            <i class="fas fa-bars"></i>
        </div>

        <div  @click="showprofile = !showprofile" class="circlehamburger" :class="{outani : !showprofile}" >
            <i class="fas fa-times"></i>
        </div>

<!--         <div class="menutop_mobile has-text-white is-size-3" :class="{closemenu: showprofile}">
            <div style="height: 100%; display: flex; align-items: center; position: relative; left: 20px;"> 
            <span class=" has-text-weight-semibold">Great</span>Growth
            </div>
        </div> -->

            <!-- menu -->
            <div class="column is-4 box-step pd-5 bgcolor h-100" :class="{res_profile: showprofile}" >
                <div style="width:90%;float:right;">
                    <div class="has-text-left">
                        <p class="is-size-4 title">{{ forms.name }}</p>
<!--                         {{ profileLogoMentor }}
                        <div v-if="profileLogoMentor == ''" class="noimgprofile">
                            
                        </div>
                        
                        <div v-else :style="{ backgroundImage: 'url('+ imgPath + profileLogoMentor + ')' }" class="imgprofile" ></div> -->
                        <div id="preview" >
                           <label for="uploadfile">
                            <div class="circle-img" v-if="profileLogoMentor != ''">
                               <img  class="haveimg" :src="imgPath+profileLogoMentor" />
                            </div>
                            <div v-else class="noimg">
                                <div class="font">170 x 170</div>
                                <div class="circle-noimg"></div>
                            </div>
                            </label>
                        </div>
                        <div class="textprofile th" style="margin-bottom:20px">
                            <p class="fontnormal th">
                            Name <span style="color:white"> {{ dataFormInput.nameMentor }} </span>
                            </p>
                            <p class="fontnormal th">
                            Living in <span style="color:white"> {{ livingInMentor }}   </span> 
                            </p>
                            <p class="fontnormal th" v-if="typeof dataFormInput.telephoneNumberMentor !== 'undefined' && typeof dataFormInput.telephoneNumberMentor.formatNational !== 'undefined'">
                            Telephone number <br><span style="color:white"> {{ dataFormInput.telephoneNumberMentor.formatNational}} </span> 
                            </p>
                             <nav class="level is-mobile" style="margin-top:6px;">
                                <div class="level-left" style="display:block;width:100%;">
                                    <a title="facebook" v-if="dataFormInput.facebookMentor"  target="_blank" :href="'https://'+dataFormInput.facebookMentor" class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-facebook-f"></i>
                                        </div>
                                    </a>
                                    <a title="linkedin" v-if="dataFormInput.linkedinMentor"  target="_blank" :href="'https://'+dataFormInput.linkedinMentor"  class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-linkedin-in"></i>
                                        </div>
                                    </a>
                                    <a title="line" v-if="dataFormInput.lineMentor"  target="_blank" :href="'https://'+dataFormInput.lineMentor" class="level-item">
                                        <div class="circle">
                                        <i class="fab fa-line"></i>
                                        </div>
                                    </a>
                                     <a title="skype" v-if="dataFormInput.skypeMentor"  target="_blank" :href="'https://'+dataFormInput.skypeMentor" class="level-item">
                                        <div class="circle">
                                       <i class="fab fa-skype"></i>
                                        </div>
                                    </a>
                                    <a title="hangout" v-if="dataFormInput.hangoutsMentor"  target="_blank" :href="'https://'+dataFormInput.hangoutsMentor"  class="level-item">
                                        <div class="circle" style="color: #0d6aca; font-weight: bold;">
                                          H
                                        </div>
                                    </a>
                                    <a title="zoom" v-if="dataFormInput.zoomMentor"  target="_blank" :href="'https://'+dataFormInput.zoomMentor" class="level-item">
                                        <div class="circle" style="color: #0d6aca; font-weight: bold;">
                                        Z
                                        </div>
                                    </a>
                                </div>
                            </nav>
                        </div>
                        
                      
                        <aside v-if="renderFormAside === true" class="menu">
                            <ul class="menu-list" v-for="(component,index) in forms.components" :key="index">
                            
                                <li>
                                    <b-collapse  :aria-id="component.key">
                                        <a 
                                            @click="setFormComponent(component)"  
                                            href="#" 
                                            v-scroll-to="'#M'+component.key" 
                                            :class="{activemenu :component.componentName == activecomponent }"  
                                            class="word-b-all is-flex align-center" 
                                            style="position:relative"
                                            :title="component.componentName"
                                            slot-scope="props"
                                            slot="trigger" 
                                        >
                                        <span> 
                                                <span class="is-size-5 mg-1 is-multiline">{{component.componentName}}</span>
                                                <b-icon v-if="getCompelete(component.key) === true" pack="fas" size="is-small" icon="check-circle" class="iconcustom"></b-icon>
                                            </span>
                                            
                                        </a>
                                        <ul :aria-controls="component.componentName+''+index">
                                        </ul> 
                                    </b-collapse>
                                </li>
                            </ul>
                        </aside>
                    </div>
                </div>
            </div>
            <!-- menu -->
                <div class="column scrollPage is-8 top_mobile" :class="{anitop_mobile : showprofile}">
                    <div class="columns">
                        <div class="column is-10 mg-x-auto is-four-fifths marginmobile">
                       <!-- {{ $route.fullPath }} -->
                        <FormInput 
                            v-if="renderForm === true && !issubmitpage"
                            :propsComponentForm="formsChildren"
                            :depth="0"
                            :validPorps="inputValidate"
                            :formType="forms.type"
                            :inputValue="inputValue"
                            :compeleteKey="compeleteKey"
                            :compeleteFormData="compeleteFormData"
                            :formId="forms._id"
                            :checkVarDes="checkVarDes"
                            :checkModelValue="checkModelValue"
                            @setRenderComponent="setRenderComponent"
                            @fetchDataForm="fetchDataForm"
                            @setMatchId="setMatchId"
                            :matchId="matchId"
                        />
                        <submitmentor @changepage="changepage" v-if="issubmitpage"></submitmentor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>

</template>

<script>
import {HTTP,HTTPDynamic} from "@/axios.js";
import FormSubTab from './FormSubTab'
import FormInput from './FormInput'
import submitmentor from './submitmentor'

export default {
    components:{
        FormSubTab,
        FormInput,
        submitmentor
    },
    data() {
        return {
            widthMax: window.innerWidth,
            forms:[],
            imgPath:process.env.VUE_APP_IMG_PROFILE,
            isLoadingPage:false,
            renderForm:false,
            renderFormAside:false,
            stepIndex:0,
            formsChildren:[],
            dataFormInput:{},
            inputValue:{},
            dataInputKpi:{},
            inputValidate:{},
            checkModelValue:{},
            checkVarDes:{},
            dataKpi:{},
            updateDateForm:null,
            asideMenu:null,
            compeleteKey:[],
            compeleteFormDataAll:[],
            compeleteFormData:[],
            matchId:{},
            matchIdDel:[],
            matchIdradio:{},
            activecomponent:'',
            showprofile: false,
            issubmitpage:false,
            profileLogoMentor:'',
            livingInMentor:'',
        }
    },
    computed: {
        beforedataform(){
            if(this.$store.state.beforedataform == null){
                return false
            }else{
                return true
            }
        },
        token(){
            return this.$store.state.token
        },
        idlogin(){
            return this.$store.state.idlogin
        },
        user(){
            return this.$store.state.islogin
        },
        selectmenu(){
            return this.$store.state.selectmenu
        },
        datasignup(){
            return this.$store.state.datasignup
        },
        showsummary(){
            if(this.compeleteFormData.length == 5){
                return true
            }else{
                return false
            }
        },
    },
    mounted() {
        this.isLoadingPage = true
        this.fethFormAll()
    },
    methods: {
        async changepage(data){
            window.scrollTo(0,0);
            this.showprofile = !this.showprofile
            this.isselectmenu(data)
        },
        isselectmenu(data){
            if(data){
                if(data.isedit){
                    var data = {
                        label : data.label,
                         isedit : false,
                }
                let findmenu = this.forms.components.filter(val => val.componentName == data.label)
                this.setFormComponent(findmenu[0])
                    
            }
            }
        },
        gosummary(){
            this.issubmitpage = true
            this.showprofile = !this.showprofile
            this.activecomponent = 'Summary'
            // this.beforedataform
            this.senddatatomentor(this.$store.state.beforedataform)
        },
        senddatatomentor(dataForm){
            //console.log('datadatadatadasdasdasdaata',dataForm)
            var mentorinvestment = {
                mentor:false,
                investment:false,
            }
            for (let d = 0; d < dataForm.input.whoAreYou.length; d++) {
                if(dataForm.input.whoAreYou[d].value == 'mentor'){
                    mentorinvestment.mentor = true
                }
                if(dataForm.input.whoAreYou[d].value == 'investment'){
                    mentorinvestment.investment = true
                }
            }
            //console.log('31231231231',dataForm.input.loveVolunteer)
            var volunteer
            if(dataForm.input.loveVolunteer != null){
                volunteer =  dataForm.input.loveVolunteer.map(obj =>{ 
                    var data = {};
                    data['index'] = obj.index;
                    data['name'] = obj.value;
                    return data;
                }) 
            }
            //console.log('volunteervolundddteer',volunteer)
            var wantVolunteer
            if(dataForm.input.wantVolunteer != null){
                wantVolunteer =  dataForm.input.wantVolunteer.map(obj =>{ 
                    var data = {};
                    data['index'] = obj.index;
                    data['name'] = obj.value;
                    return data;
                })
            }


            var industryInterested 
            if(dataForm.input.areYouInterestedInInvesting != null){
                industryInterested = dataForm.input.areYouInterestedInInvesting.map(obj =>{ 
                    var data = {};

                     if(obj.label == 'Other'){
                        data['index'] = obj.index;
                        data['name'] = obj.des;
                    }else{
                        data['index'] = obj.index;
                        data['name'] = obj.label;
                    }
                    return data;
                })
            }
            //console.log('industryInterestedindustryInterestedindustryInterested',industryInterested)
            // console.log('dataForm.input.whichSizeOfInvestment',dataForm.input.whichSizeOfInvestment)
            var sizeInvestment 
            if(dataForm.input.whichSizeOfInvestment != null){
                sizeInvestment = dataForm.input.whichSizeOfInvestment.map(obj =>{ 
                    var data = {};
                    data['index'] = obj.index;
                    data['name'] = obj.label;
                    return data;
                })
            }

            var language
            if(dataForm.input.talkWellInMentor != null){
                language = dataForm.input.talkWellInMentor.map(obj =>{ 
                    var data = {};
                    data['index'] = obj.index;
                    data['name'] = obj.label;
                    return data;
                })  
            }
            var industryExpertise
            if(dataForm.input.industryexpertise != null){
                industryExpertise = dataForm.input.industryexpertise.map(obj =>{ 
                    var data = {};
                    if(obj.label == 'Other'){
                        data['index'] = obj.index;
                        data['name'] = obj.des;
                    }else{
                        data['index'] = obj.index;
                        data['name'] = obj.label;
                    }
                    return data;
                })
            }

            var gender
            if(dataForm.input.genderMentor.data != null && typeof dataForm.input.genderMentor.data != 'undefined' ){
                gender = dataForm.input.genderMentor.data.label == 'Male' ? 1 : 2
            }
           
  
        
        var hourlyRate = ''
        if(dataForm.input.hourlyRate != null && typeof dataForm.input.hourlyRate != 'undefined' ){
            hourlyRate = dataForm.input.hourlyRate.label
        }
        //console.log('dataForm.input.hourlyRate.label',dataForm.input.hourlyRate.label)
        //console.log('gendergendergender',gender)
            
           let dataformSend =  {
            userId:this.idlogin,
            detailUser:[
			{    mentor:mentorinvestment.mentor,
                investment: mentorinvestment.investment,
                volunteer,
				wantVolunteer,
				hourlyRate,
				amountHourly: dataForm.input.hourlyRateAmount,
				industryInterested: industryInterested,
				sizeInvestment,
                name : dataForm.input.nameMentor,
                surname: dataForm.input.surenameMentor,
                nickName: dataForm.input.nicknameMentor,
				dateOfBirth : dataForm.input.dateofBirthMentor,
				living: (typeof dataForm.input.livingMentor !== 'undefined' && dataForm.input.livingMentor != null) ? dataForm.input.livingMentor :'' ,
                gender,// 1 male // 2 female
                countryCode:dataForm.input.countryCode,
                telephoneNumber:dataForm.input.telephoneNumberMentor, // !
                email:dataForm.input.emailMentor,
				websit: dataForm.input.websiteMentor,
				profilePic: dataForm.input.profileLogoMentor.name,
				aboutMe: dataForm.input.anoutMe,
				professionTitle: dataForm.input.professionTitle,
				social: {
					facebook: dataForm.input.facebookMentor,
					linkedin:dataForm.input.linkedinMentor,
					line: dataForm.input.lineMentor,
					skype: dataForm.input.skypeMentor,
					hangouts:dataForm.input.hangoutsMentor,
					zoom: dataForm.input.zoomMentor
				},
				language,
				industryExpertise,
			 }
                    ]
            }
            this.$store.commit('senddatamentor',dataformSend)

        },
        async fethFormAll(){
                let data ={
                    keyRequest:this.token
                }
                HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
                await HTTPDynamic.post(`api/get/form`,data)
                .then(res => {
                    // console.log("api/get/form",res.data); 
                    if (res.data.success) {
                        let filter = res.data.obj.form.filter(filter => filter.component._id === '5ce2bbe036353710e0179273')
                        let forms = (filter.length > 0)?filter[0]:{}
                        if (forms.type === 'component') {
                            this.forms =  (typeof forms !== 'undefined')?forms.component:[]
                        }else{
     
                            this.forms ={
                                _id:forms.component._id,
                                type:forms.type,
                                name:forms.component.name,
                                components:[]
                            }
                
                            for (let index = 0; index < forms.component.components.length; index++) {
                                setTimeout(() => {         
                                    this.getComponent(forms.component.components[index].componentId,this.forms.components).then(()=>{
                                        this.fetchComponentChildren(forms.component.components[index].children,this.forms.components[index])
                                    })
                                }, 500*index);
                            }
                        }
                        
                    }else{
                        this.forms = []
                    }
                    
                    this.renderFormAside = true 
                })
                .catch(e => {   
                    this.isLoadingPage = false      
                    console.log("api/get/form/error",e);
                });

                setTimeout(() => {
                    this.asideMenu=this.forms.components[0].key
                    this.formsChildren.push(this.forms.components[0]) 
                    this.fetchDataForm()                  
                }, 4000);
        },
        async getComponent(id,form){
            let data ={
                keyRequest:this.token,
                componentId:id
            }


            await HTTPDynamic.post(`api/get/component/by/prod`,data)
            .then(res => {

                if (res.data.success) {
                    if (typeof res.data.obj.components !== 'undefined' ) {
                        for (let index = 0; index < res.data.obj.components.length; index++) {
                  
                            form.push(res.data.obj.components[index])
                        }
                    }  
                }else{
                    this.form = []
                }
                
            })
            .catch(e => {
                console.log("get/component/by/id/error",e);
            });
        },
        async fetchComponentChildren(component,form){
            let res =null
            if (component.length > 0) {
                for (let index = 0; index < component.length; index++) {
                    setTimeout(() => {
                        if (typeof form !== 'undefined') {
                        this.getComponent(component[index].componentId,form.children)
                    } 
            
                
                    res = form
                    if (component[index].length > 0) {
                        this.fetchComponentChildren(component[index].children,res)
                    } 
                    }, 500*index);
                }
            }

        },
        async fetchDataForm(){
            this.inputValue = {}
            this.inputValidate = {}
            this.compeleteKey = []
            this.compeleteFormDataAll = []
                // companyId:"",
                // roleId:"mentor",
            let data ={
                componentId:this.forms._id,
                companyId:this.idlogin,
                roleId:"mentor",
                keyRequest:this.token
            }

            await HTTPDynamic.post(`get/data/form/prod`,data)
            .then(res => {
                // console.log("get/data/form", res);  
                if (res.data.success) {
                    this.dataFormInput = res.data.obj.data[0].input
                    if(res.data.obj.data[0].input.profileLogoMentor.name != null ){
                        this.profileLogoMentor = res.data.obj.data[0].input.profileLogoMentor.name
                    }else{
                        this.profileLogoMentor = this.user.detailUser[0].profilePic
                    }
                    if(typeof res.data.obj.data[0].input.livingMentor !== 'undefined' && res.data.obj.data[0].input.livingMentor){
                        this.livingInMentor = res.data.obj.data[0].input.livingMentor
                    }

                    this.compeleteFormData = res.data.obj.data[0].complete
                    this.setValidForm(this.formsChildren)
                    this.setValueForm(this.forms.components)

                    let invest = (typeof res.data.obj.data[0].input.areYouInterestedInInvesting !== 'undefined')?res.data.obj.data[0].input.areYouInterestedInInvesting:[]
                  
                    this.$store.commit('setInvestMath',invest)
                }else{
                    this.dataFormInput = {nameMentor:this.user.detailUser[0].name}
                    this.compeleteFormData = []
                    this.profileLogoMentor = this.user.detailUser[0].profilePic
                    this.setValidForm(this.formsChildren)
                    this.setValueForm(this.forms.components)
                    this.$store.commit('setInvestMath',[])
                }
                
                setTimeout(() => {
                    this.$store.commit('setPercent',this.getPercenrComplete())
                    let compeleteIntro = this.getCompelete('5cd3bb1d30bc8300705fd9ea1558362641933')
                    this.$store.commit('setShowTicket',compeleteIntro)
                }, 1000);
            })
            .catch(e => {
                console.log("get/data/form/error",e);
            });
          
        },
        getPercenrComplete(){
            if (typeof this.compeleteFormData !== 'undefined') {
                let percent = Math.round((100 / this.compeleteFormDataAll.length)*this.compeleteFormData.length)
                return percent
            }else{
                return 0
            }
        },
       async setValueForm(components){
            let value = []

            await components.map(async(component)=>{
                this.compeleteFormDataAll.push(component.key)
                await component.componentData.map((item)=>{
  
                    if (item.type === 'checkbox') {
               
                        this.inputValue[item.name] = (typeof this.dataFormInput[item.name] !== 'undefined')?this.dataFormInput[item.name]:[]
                        if (typeof this.dataFormInput[item.name] !== 'undefined') {
                            
                            this.checkModelValue[item.name] = []
        
                            for (let index = 0; index < this.dataFormInput[item.name].length; index++) {
                                this.checkModelValue[item.name].push({label:this.dataFormInput[item.name][index].label,value:this.dataFormInput[item.name][index].value,userValue:this.dataFormInput[item.name][index].userValue,index:this.dataFormInput[item.name][index].index})
                            }
            
                            for (let index = 0; index < item.display.value.length; index++) {  
                                let data = this.dataFormInput[item.name].filter(itemInput => itemInput.label === item.display.value[index].label)   
                                if (typeof item.display.value[index] !== 'undefined' && item.display.value[index].userValue === true) {  
                                    if (data.length > 0) {
                                        this.checkVarDes[item.name+data[0].index] = {index:index,des:data[0].des}
                                    }else{
                                        this.checkVarDes[item.name+index] = {index:index,des:null}
                                    }
                                }
                                if ( item.display.value[index].Keyid !== '' && typeof this.dataFormInput[item.name] !== 'undefined') {
                                    if (data.length > 0) {
                                        this.matchId[item.display.value[index].Keyid] = item.display.value[index].Keyid
                                        this.setMatchId(this.checkModelValue[item.name], item.display.value[index],component,'checkbox')
                                    }
                                }
                            }
                            
                        }else{
                      
                            this.checkModelValue[item.name] = []  
                            for (let index = 0; index < item.display.value.length; index++) {
                                if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                    this.checkVarDes[item.name+index] = {index:index,des:null}
                                }

                                if ( item.display.value[index].Keyid !== '') {
                                    this.matchId[item.display.value[index].Keyid] = ''
                                }
                            }
                            
                        }
                    }else if (item.type === 'date') {
                        this.inputValue[item.name] = (typeof this.dataFormInput[item.name] !== 'undefined')?this.dataFormInput[item.name]:null
                    }else if (item.type === 'file') {
                        if(item.name == 'profileLogoMentor'){
                            if(typeof this.dataFormInput[item.name] !== 'undefined'){
                                this.inputValue[item.name] = this.dataFormInput[item.name]
                            }else{
                                this.inputValue[item.name] = {name :''}
                            }
                            
                        }else{
                           this.inputValue[item.name] = (typeof this.dataFormInput[item.name] !== 'undefined')?this.dataFormInput[item.name]:'' 
                        }
                        
                    }else if (item.type === 'radio') {
                        this.inputValue[item.name] = (typeof this.dataFormInput[item.name] !== 'undefined')?{data:this.dataFormInput[item.name].data,des:null}:{data:null,des:null}
                        for (let index = 0; index < item.display.value.length; index++) {
                          
                            if (typeof this.dataFormInput[item.name] !== 'undefined' && item.display.value[index].userValue === true) {
                                this.inputValue[item.name]['des'] = (typeof this.dataFormInput[item.name] !== 'undefined')?this.dataFormInput[item.name].des:null 
                            }
                            
                            if ( item.display.value[index].Keyid !== '') {
                                
                                if (typeof this.dataFormInput[item.name] !== 'undefined'&& this.dataFormInput[item.name].data !== null && this.dataFormInput[item.name].data.label === item.display.value[index].label) {
                                    
                                    this.matchId[item.display.value[index].Keyid] = item.display.value[index].Keyid
                                    this.setMatchId(item.display.value, item.display.value[index],component,'checkbox')
                                }else{
                                    this.matchId[item.display.value[index].Keyid] = ''
                                }
                                
                                
                            }
                        }
                    }else{         
                        this.inputValue[item.name] = (typeof this.dataFormInput[item.name] !== 'undefined')?this.dataFormInput[item.name]:null
                        
                        // if (typeof this.dataFormInputAdd[item.name] !== 'undefined' && this.dataFormInputAdd[item.name].length > 0) {
                        //     this.inputFormData[item.name] = []
                           
                        //     for (let index = 0; index < this.dataFormInputAdd[item.name].length; index++) {
               
                        //         this.inputValidate[this.dataFormInputAdd[item.name][index].name] = {name:this.dataFormInputAdd[item.name][index].name,validation:this.dataFormInputAdd[item.name][index].validation,type:this.dataFormInputAdd[item.name][index].type,valid:false,hidden:false}
                        //         this.inputValue[this.dataFormInputAdd[item.name][index].name] = this.dataFormInput[this.dataFormInputAdd[item.name][index].name]
                        //         this.inputFormData[item.name].push(this.dataFormInputAdd[item.name][index])
                        //     }
                        // }


                        if (typeof item.options !== 'undefined' && typeof item.options.repeat !== 'undefined' && item.options.repeat === true) {

                            if (typeof this.dataKpi[item.name] !== 'undefined') {

                                let obj ={
                                    repeatStart:item.options.repeatStart,
                                    everyRepeat:item.options.everyRepeat,
                                    repeatStop:item.options.repeatStop
                                    
                                }
                                this.dataInputKpi[item.name] = {type:item.type,input:this.dataKpi[item.name].input,lastUpdate:new Date(this.dataKpi[item.name].lastUpdate),repeatStop:false,repeat:obj,nameLabel:item.display.label}
            
                                let count = 1
                                let repeatDate = new Date(item.options.repeatStart)
                                let repeatStartNum = repeatDate.getMonth()
                                let updateDateForm = new Date(this.dataKpi[item.name].lastUpdate).getFullYear()+'-'+(new Date(this.dataKpi[item.name].lastUpdate).getMonth()+1)+'-'+new Date(this.dataKpi[item.name].lastUpdate).getDate()     
                                while (repeatDate.getTime() <= new Date().getTime()) {
                                    if (typeof this.dataKpi[item.name].lastUpdate !== 'undefined' && new Date().getTime() >= repeatDate.getTime()) {
                                        
                                        if (new Date(updateDateForm).getTime() < repeatDate.getTime()) {
                                            
                                            this.inputValue[item.name] = null
                                        }else{
                                            this.inputValue[item.name] = (value.length !== 0)?this.dataFormInput[item.name]:null
                                        }
                                    }

                                    repeatDate= new Date(item.options.repeatStart)
                                    repeatDate.setMonth(repeatStartNum+ (item.options.everyRepeat*count), 1)
                                    count++
                                    
                                }   
                            }else{

                                let obj ={
                                    repeatStart:item.options.repeatStart,
                                    everyRepeat:item.options.everyRepeat,
                                    repeatStop:item.options.repeatStop
                                    
                                }
                                this.dataInputKpi[item.name] = {type:item.type,input:"",lastUpdate:null,repeatStop:true,repeat:obj,nameLabel:item.display.label}
                            }
                        }
                    } 
                })
            
            
                if (component.children.length > 0) {
                    await this.setValueForm(component.children) 
                }else{
                    this.isLoadingPage = false
                    this.renderForm = true
                }
                
            })
        },
             async setValidForm(components){
            await components.map(async(component)=>{
                this.compeleteKey.push(component.key)
                await component.componentData.map((item)=>{
                    if (item.display.matchid !== '') {
                        this.inputValidate[item.name] = {name:item.name,validation:item.validation,type:item.type,valid:false,hidden:true}
                        if (item.type === 'radio') {  
                            for (let index = 0; index < item.display.value.length; index++) {
                                if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                    this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'radioDes',valid:false,hidden:true}
                                }
                            }
                        }

                        if (item.type === 'checkbox') {  
                            for (let index = 0; index < item.display.value.length; index++) {
                                
                                if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                    this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'checkBoxDes',valid:false,hidden:true}
                                }
                            }
                        }
                    }else{
                        this.inputValidate[item.name] = {name:item.name,validation:item.validation,type:item.type,valid:false,hidden:false}
                        if (item.type === 'radio') {  
                            for (let index = 0; index < item.display.value.length; index++) {
                                if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                    this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'radioDes',valid:false,hidden:false}
                                }
                            }
                        }

                        if (item.type === 'checkbox') {  
                            for (let index = 0; index < item.display.value.length; index++) {
                                
                                if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                    this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'checkBoxDes',valid:false,hidden:false}
                                }
                            }
                        }
                    }
                    
                })
            
                if (component.children.length > 0) {
                    await this.setValidForm(component.children) 
                } 
            })
        
        },

   async setValueMatch(components,keyId,status){
            await components.map(async(component)=>{
                await component.componentData.map((item)=>{
                     if (typeof item.display.matchid !== 'undefined' && typeof item.display.matchid !== '') {
                        // let key = keyId.filter(key=>key === item.display.matchid)
                        if (keyId === item.display.matchid) {
                            if (status === true) {                 
                                this.inputValidate[item.name] = {name:item.name,validation:item.validation,type:item.type,valid:false,hidden:false} 
                            }else{
                                this.inputValidate[item.name] = {name:item.name,validation:item.validation,type:item.type,valid:false,hidden:true}
                            }

                            if (item.type === 'radio') {  
                                for (let index = 0; index < item.display.value.length; index++) {
                                    if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                        if (status === true) {
                                            this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'radioDes',valid:false,hidden:false}
                                        }else{
                                            this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'radioDes',valid:false,hidden:true}
                                        }
                                        
                                    }
                                }
                            }

                            if (item.type === 'checkbox') {  
                                for (let index = 0; index < item.display.value.length; index++) {
                                    if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                        if (status === true) {
                                            this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'checkBoxDes',valid:false,hidden:false}
                                        }else{
                                            this.inputValidate[item.name+'UserValue'+index] = {name:item.name,validation:{errorMsg: "กรุณากรอกข้อความ",required: true},type:'checkBoxDes',valid:false,hidden:true}
                                        }
                                    }
                                }
                            }

                            if (item.type === 'checkbox') {
                                this.inputValue[item.name] = [] 
                                this.checkModelValue[item.name] = []      
                                for (let index = 0; index < item.display.value.length; index++) {
                                    if (item.display.value[index].Keyid !== '') {
                                        this.matchId[item.display.value[index].Keyid] = '' 
                                    }  
                                    if (typeof item.display.value[index].userValue !== 'undefined' && item.display.value[index].userValue === true) {
                                        this.checkVarDes[item.name+index] = {index:index,des:null}
                                    }
                                }
                            }else if (item.type === 'date') {
                                this.inputValue[item.name] = null
                            }else if (item.type === 'file') {
                                this.inputValue[item.name] = []
                            }else if (item.type === 'radio') {
                       
                                this.inputValue[item.name] = {data:null,des:null}
                                for (let index = 0; index < item.display.value.length; index++) {
                                    if (item.display.value[index].Keyid !== '') {
                                        this.matchId[item.display.value[index].Keyid] = ''                
                                    }  
                                }
                            }else{         
                                this.inputValue[item.name] = null
                            }

                        }
                         
                    }
                    
                })
            
            
                if (component.children.length > 0) {
                    await this.setValueMatch(component.children,keyId) 
                }else{
                    this.renderForm = true   
                }
                
            })
        },

        setFormComponent(data){
            this.issubmitpage = false
            this.showprofile = !this.showprofile
            this.activecomponent = data.componentName
            // alert(data)
            this.isLoadingPage = true
            this.renderForm = false
            this.asideMenu=data.key
            this.inputValidate = {}
            this.formsChildren = []
            this.formsChildren.push(data)
            this.compeleteKey = []
            this.compeleteFormDataAll = []
            this.setValidForm(this.formsChildren)
            this.setValueForm(this.forms.components)          
        },
        getCompelete(key){
            // console.log(this.compeleteFormData)
            let data = this.compeleteFormData.filter(item => item === key)
            // console.log(data)
            if (data.length > 0) {
                return true  
            }else{
                return false
            }
        },
        setRenderComponent(status){
            this.renderForm = status
            setTimeout(() => {
                if (status === true) {
                    this.renderForm = false
                }else{
                    this.renderForm = true
                } 
            }, 1);

        },
        setMatchId(data,value,component,type){
            
            if (type === 'radio') {  
                if (value.Keyid !== '') {
                    for(let index in data){
                        if (data[index].Keyid === value.Keyid) {
                            this.matchId[data[index].Keyid] = value.Keyid
                            this.renderForm = false
                           this.setValueMatch([component],data[index].Keyid,true)
                        }else{
                            this.matchId[data[index].Keyid] = ''
                            this.renderForm = false
                            this.setValueMatch([component],data[index].Keyid,false)
                        }
                    }
                }
            }else{
                let res = data.filter(item => item.label === value.label)
              
                if (value.Keyid !== '') {
                    if (res.length > 0) {
                        this.matchId[value.Keyid] = value.Keyid
                        this.renderForm = false
                        this.setValueMatch([component],value.Keyid,true)
                    }else{
                        this.matchId[value.Keyid] = ''
                        this.renderForm = false
                        this.setValueMatch([component],value.Keyid,false)
            
                    }
                }
            }
            
        },


    },
}
</script>
<style scoped>
.level.is-mobile .level-item:not(.is-narrow){
    float: left; margin-top: 4px;margin-right: 5px;
}
.circle-img{
  width:140px;
  height:140px;
  overflow:hidden;
  display:flex;
  border-radius: 50%;
  border:2px solid #ebebeb;
  justify-content: center;
  align-content: center;
  float: left;
}
.circle-img img{
    height: 100%;
    max-width: unset!important;
}
#preview .noimg{
    position:relative;
    float: left;
}
#preview .noimg .font{
    position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);
}
#preview .noimg .circle-noimg{
    border-radius: 50%; height: 140px !important; width: 140px !important; background:#cccccc; margin: 0 auto;
}
.buttonorange{
     padding: 5px 2rem;
    font-weight: 600;
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
    margin: 0 auto;
    display: block;
}
.circle{
        border-radius: 50%;
    background: white;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 28px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
}
.circle i {
    color:#0d6aca;
}

a.has-text-primary:hover, a.has-text-primary:focus{
  color: white !important;
}
.activemenu .iconcustom{
        color: #0FB9F4 !important;
    right: 27% !important
}
.menu-list a:hover{
           width: 139%;
    box-shadow: 0 0 0 1px white;
 border-radius: 42px;
}

.menu-list a:hover span.icon{
           right: 27% !important
}


.menu-list a.activemenu:hover{
           width: 139%;
    border: none;
}

.iconcustom{
    color: white ; position: absolute; right: 0; top: 50%; transform: translateY(-50%)
}
.activemenu .iconcustom{
    right: 4vw;
    color: #0FB9F4;
}
.menu-list a{
        width: 139%;
    color: white ;
}
.collapse-trigger .word-b-all .icon.is-small{
        right: 27% !important
}


 /* .collapse-content .word-b-all{
width:103% !important;
} */

/* .menu-list a:hover{
    color: white ;
    background-color: transparent ;
} */

.fontbold{
  font-weight: bold;
font-size: 14px;
color: white;
}
.textprofile{
    float: left;
    width: calc( 100% - 140px);
    min-height: 140px;
    padding: 10px 10px 10px 20px;
}
.title{
        color: white;
    padding-left: 11px;
    font-weight: bold;
    margin-bottom: 15px;
}
.noimgprofile{
    float: left;
    background: #89C3FE;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
width: 140px;
    height: 140px;
    border-radius: 70px;
}
.imgprofile{
    float: left;
    /* background: #89C3FE; */
    /* background: url("../../assets/Intersect.png"); */
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    width: 140px;
    height: 140px;
    border-radius: 70px;
}

.bgcolor{
    overflow:hidden !important;border-color:white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
}
.buttonc{
        padding-left: 2rem;
    padding-right: 2rem;
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}
    /* .b-checkbox.checkbox{
        border: 1px solid blue !important;
    padding: 0;
    } */
    .box-percent{
        border: solid;
        border-radius: 7.5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin:100px;
        height: 100px;
    }
    .percent{
        font-size: 30px;
        font-weight: bold;
    }
    .box-step{
        /* border-right: solid; */
        border-right-width: 1px;
        border-color: #dbdbdb;
    }
    .ps-fixed{
        position: fixed!important;
        width: 39%!important;
    }
    .activemenu{
            background: white;
    border-radius: 42px;
    color: black !important;
    padding-left: 20px;
    width: 27vw;
    padding-top: 12.5px;
    padding-bottom: 12.5px;
    }
    .activemenu:hover{
        background: white;
        background-color:white !important;
    }
 
.menu-list{
        margin: 10px 0;
}

.circlehamburger{
    display: none;
    height: 50px;
    width: 50px;
    position: fixed;
    background: #0d6aca;
    color: white;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    transition: all 0.5s;
    z-index: 100;
}

.bgcolor{
    transition: all 0.5s;
}

.menutop_mobile .fontbold2{
    display: none
}

@media only screen and (max-width: 770px) {
    .fixhidden{
    overflow: hidden;
height: 100vh;
}
    .menutop_mobile .fontbold2{
    display: block
}
  
 .circlehamburger{
    display: flex;
}
.activeani{
    opacity: 1;
    right: 0.6vw;
}
.outani{
    opacity: 0;
        right: -20vw;
}
.bgcolor{
    width: 0;
    padding: 0 !important;
    min-width: 0 !important;
    position: absolute;
    height: 0;
    min-height: 0;
    padding: 0 !important;
    opacity: 0;
}
.bgcolor .has-text-left{
    opacity: 0;
}

.res_profile{
    display: block !important;
    width: 100.5% !important;
    height: 100vh !important;
    padding: 1.5rem!important;
    z-index: 99;
    opacity: 1;
    right:0;
}
.res_profile .has-text-left{
    opacity: 1;
}

.menutop_mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
    background: #0d6aca;
    z-index: 99;
    transition: all 0.5s;
}

.top_mobile{
    margin-top: 40px;
    transition: all 0.5s;
}
.anitop_mobile{
    margin-top: 0;
}
.closemenu{
  height: 0rem;
  opacity: 0;
}
.closemenu .fontbold2{
    opacity: 0
}
}
</style>
<style>
.menu-list a:hover{
    background: transparent;
    background-color: transparent !important;
    color: white ;
}
.menu-list a{
    color: white !important;
}
.help.is-danger {
    right: 4px !important;
    top: 2.5rem !important;
}
</style>
